
import React from "react";
import ProfileTextField from "./ProfileTextField";

interface ProfileLocationFieldsProps {
  country: string;
  state: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  disabled: boolean;
}

const ProfileLocationFields: React.FC<ProfileLocationFieldsProps> = ({
  country,
  state,
  onChange,
  disabled
}) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      <ProfileTextField
        id="country"
        name="country"
        label="Country"
        value={country}
        onChange={onChange}
        placeholder="Your country"
        disabled={disabled}
      />
      
      <ProfileTextField
        id="state"
        name="state"
        label="State/Province"
        value={state}
        onChange={onChange}
        placeholder="Your state or province"
        disabled={disabled}
      />
    </div>
  );
};

export default ProfileLocationFields;
